import {RouteContext} from "../../RouteContext";
import React from "react";
import { Styles } from "../../common/Styles";
import {InputStringStatePair, StatePair, useError, useInputString, useStatePair} from "../../../../type/States";
import {Button, Field, FieldProps, Input, Label, Radio, RadioGroup} from "@fluentui/react-components";
import {DataTransferObjectValidation} from "../../../../type/Types";
import {Column, Row} from "../../common/Layout";
import {
    PlaceSummaryFunnelStatsDataTransferObject
} from "../../../../model/dto/content/place/stats/PlaceSummaryFunnelStatsDataTransferObject";
import {PlaceFunnelIO} from "../../../../io/content/place/PlaceFunnelIO";
import {getFormattedDateString} from "../../../../utils/formatDate";
import {AddFilled} from "@fluentui/react-icons";
import {PlaceDataTransferObject} from "../../../../model/dto/content/place/PlaceDataTransferObject";

export default function Post(props: RouteContext) {
    const styles = Styles.useEditorStyles()
    const postErrorState = useError()
    const isPeriod = useStatePair<boolean>(false)

    const startDateInputStates: Record<keyof PlaceSummaryFunnelStatsDataTransferObject.Date, InputStringStatePair> = {
        year: useInputString(''),
        month: useInputString(''),
        day: useInputString(''),
    }
    const startDateInputValidationStates: Record<keyof PlaceSummaryFunnelStatsDataTransferObject.Date, StatePair<FieldProps['validationState']>> = {
        year: useStatePair<FieldProps['validationState']>('none'),
        month: useStatePair<FieldProps['validationState']>('none'),
        day: useStatePair<FieldProps['validationState']>('none'),
    }

    const endDateInputStates: Record<keyof PlaceSummaryFunnelStatsDataTransferObject.Date, InputStringStatePair> = {
        year: useInputString(''),
        month: useInputString(''),
        day: useInputString(''),
    }
    const endDateInputValidationStates: Record<keyof PlaceSummaryFunnelStatsDataTransferObject.Date, StatePair<FieldProps['validationState']>> = {
        year: useStatePair<FieldProps['validationState']>('none'),
        month: useStatePair<FieldProps['validationState']>('none'),
        day: useStatePair<FieldProps['validationState']>('none'),
    }

    const inputStates: Record<keyof PlaceSummaryFunnelStatsDataTransferObject.Post, InputStringStatePair> = {
        exposedAtList: useInputString(''),
    }
    const inputValidationStates: Record<keyof PlaceSummaryFunnelStatsDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        exposedAtList: useStatePair<FieldProps['validationState']>('none'),
    }

    const onDoneClick = () => {
        inputValidationStates.exposedAtList.setValue('none')
        try {
            const dto: PlaceSummaryFunnelStatsDataTransferObject.Post = {
                exposedAtList: DataTransferObjectValidation.validate(PlaceSummaryFunnelStatsDataTransferObject.Post.validation, 'exposedAtList', inputStates.exposedAtList.value, () => inputValidationStates.exposedAtList.setValue('error')),
            }

            console.log(dto)

            PlaceFunnelIO.postFunnelRecord(dto)
                .then(() => window.alert('추가되었습니다.'))
                .catch(postErrorState.setDefinedValue)
        } catch (error) {
            console.error(error)
            // @ts-ignore
            postErrorState.setDefinedValue(error)
        }
    }

    const onHandleDateInput = () => {
        try {
            const startDate: PlaceSummaryFunnelStatsDataTransferObject.Date = {
                year: DataTransferObjectValidation.validate(PlaceSummaryFunnelStatsDataTransferObject.Date.validation, 'year', startDateInputStates.year.value, () => startDateInputValidationStates.year.setValue('error')),
                month: DataTransferObjectValidation.validate(PlaceSummaryFunnelStatsDataTransferObject.Date.validation, 'month', startDateInputStates.month.value, () => startDateInputValidationStates.month.setValue('error')),
                day: DataTransferObjectValidation.validate(PlaceSummaryFunnelStatsDataTransferObject.Date.validation, 'day', startDateInputStates.day.value, () => startDateInputValidationStates.day.setValue('error')),
            }

            const start = new Date(`${startDate.year}-${startDate.month.padStart(2, '0')}-${startDate.day.padStart(2, '0')}`);
            let dates: string[] = [];

            if (isPeriod.value) {
                const endDate: PlaceSummaryFunnelStatsDataTransferObject.Date = {
                    year: DataTransferObjectValidation.validate(PlaceSummaryFunnelStatsDataTransferObject.Date.validation, 'year', endDateInputStates.year.value, () => endDateInputValidationStates.year.setValue('error')),
                    month: DataTransferObjectValidation.validate(PlaceSummaryFunnelStatsDataTransferObject.Date.validation, 'month', endDateInputStates.month.value, () => endDateInputValidationStates.month.setValue('error')),
                    day: DataTransferObjectValidation.validate(PlaceSummaryFunnelStatsDataTransferObject.Date.validation, 'day', endDateInputStates.day.value, () => endDateInputValidationStates.day.setValue('error')),
                }

                const end = new Date(`${endDate.year}-${endDate.month.padStart(2, '0')}-${endDate.day.padStart(2, '0')}`);

                if (start > end) throw new Error("시작일이 종료일보다 클 수 없습니다.");

                let current = new Date(start);
                while (current <= end) {
                    dates.push(getFormattedDateString(current));
                    current.setDate(current.getDate() + 1);
                }
            } else {
                dates.push(getFormattedDateString(start));
            }

            const existing = inputStates.exposedAtList.value
                ? inputStates.exposedAtList.value.split(',').filter(Boolean)
                : [];

            const mergedSet = new Set([...existing, ...dates]);
            const merged = Array.from(mergedSet).sort();

            inputStates.exposedAtList.setValue(merged.join(','));
        } catch (error) {
            console.error(error);
            // @ts-ignore
            postErrorState.setDefinedValue(error);
        }
    }


    return <>
        <postErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Label></Label>
            <RadioGroup
                value={isPeriod.value.toString()}
                onChange={
                    (_, data) => isPeriod.setValue(data.value === "true")
                }>
                <Radio value="true" label="기간 추가" />
                <Radio value="false" label="당일 추가" />
            </RadioGroup>
            <Field
                className={styles.field}
                label={PlaceSummaryFunnelStatsDataTransferObject.Post.description.exposedAtList}
                validationState={inputValidationStates.exposedAtList.value}>
                <Row gap={'4px'}>
                    <Input
                        value={startDateInputStates.year.value}
                        onChange={startDateInputStates.year.onChange}
                        type='number'
                        placeholder={'년도'}
                    />
                    -
                    <Input
                        value={startDateInputStates.month.value}
                        onChange={startDateInputStates.month.onChange}
                        type='number'
                        placeholder={'월'}
                    />
                    -
                    <Input
                        value={startDateInputStates.day.value}
                        onChange={startDateInputStates.day.onChange}
                        type='number'
                        placeholder={'일'}
                    />
                    {
                        isPeriod.value &&
                        <>
                            <div>~</div>
                            <Input
                                value={endDateInputStates.year.value}
                                onChange={endDateInputStates.year.onChange}
                                type='number'
                                placeholder={'년도'}
                            />
                            -
                            <Input
                                value={endDateInputStates.month.value}
                                onChange={endDateInputStates.month.onChange}
                                type='number'
                                placeholder={'월'}
                            />
                            -
                            <Input
                                value={endDateInputStates.day.value}
                                onChange={endDateInputStates.day.onChange}
                                type='number'
                                placeholder={'일'}
                            />
                        </>
                    }
                    <Button appearance={'secondary'} onClick={onHandleDateInput} icon={<AddFilled />} />
                </Row>
            </Field>
            <Column gap={'4px'}>
                <Label>추가 될 노출 일자들</Label>
                {
                    inputStates.exposedAtList.value.length > 0 &&
                    <Column gap={'4px'}>
                        {inputStates.exposedAtList.value.split(',').map(
                            v=><div>{v}</div>
                        )}
                        <Button
                            appearance="secondary"
                            onClick={() => inputStates.exposedAtList.setValue('')}
                            style={{width:'fit-content'}}>
                            초기화
                        </Button>
                    </Column>
                }
            </Column>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}